import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '../common/Icon';

interface IProps {
  defaultCheked?: boolean;
  hasError?: boolean;
  name?: string;
  onChange: (value: boolean) => void;
}

export const Checkbox: React.FC<IProps> = props => {
  const [checked, setChecked] = React.useState(props.defaultCheked);
  return (
    <Root onClick={handleClick}>
      <CheckboxStyled hasError={props.hasError} name={props.name} isActive={checked}>
        <IconBox isActive={checked}>
          <Icon name='check' width='0.9rem' color='white' />
        </IconBox>
      </CheckboxStyled>
      <Label>{props.children}</Label>
    </Root>
  );

  function handleClick() {
    const nextChecked = !checked;

    setChecked(nextChecked);
    props.onChange(nextChecked);
  }
};

const Root = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

interface ICheckboxProps {
  hasError: boolean;
  isActive: boolean;
  name: string;
}

const CheckboxStyled = styled.span<ICheckboxProps>`
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.textShadowedColor};
  transition: box-shadow 200ms;
  background-color: ${({ theme }) => theme.colors.wheelButtDark};
  box-shadow: inset 0 2px 2px 0 rgba(0, 0, 0, 0.075), inset 0 0 0 1px rgba(37, 158, 250, 0);
  border-radius: ${({ theme }) => theme.borderRadius};

  border: 1px solid ${({ theme, hasError }) => (hasError ? theme.errorColor : 'transparent')};
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0;
  overflow: hidden;
  position: relative;

  .rtl & {
    margin-right: 0;
    margin-left: 10px;
  }

  &::before {
    content: '';
    z-index: 1;
    border-radius: 50%;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    display: block;
    position: absolute;
    transition: transform 150ms;
    background-color: ${({ theme }) => theme.colors.wheelButt};
    transform: translate(-50%, -50%) scale(${({ isActive }) => (isActive ? 1.3 : 0)});
  }
`;

interface IIconBoxProps {
  isActive: boolean;
}

const IconBox = styled.span<IIconBoxProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
  transition: transform 150ms;
  transform: scale(${({ isActive }) => (isActive ? 1 : 0)});
`;

const Label = styled.label`
  font-size: 14px;
  cursor: pointer;
  color: ${({ theme }) => theme.textShadowedColor};
`;
